import { blue as blueColor, green as greenColor, grey as greyColor, red as redColor } from '@mui/material/colors';
import { isBefore, startOfTomorrow } from 'date-fns';

import { QuoteListItem, QuoteStatus } from '../../../apis/quoteApi';
import { formatDate } from '../../../utils/formatUtils';

export const quoteStatusColors = {
  sent: blueColor[500],
  approved: greenColor[500],
  rejected: redColor[500],
  expired: greyColor[500],
};

export const filterStatuses = [
  { label: 'Sent', background: quoteStatusColors.sent, lightText: true },
  { label: 'Rejected', background: quoteStatusColors.rejected, lightText: true },
  { label: 'Approved', background: quoteStatusColors.approved, lightText: true },
  { label: 'Expired', background: quoteStatusColors.expired, lightText: true },
];

export const getQuoteStatus = (quote: QuoteListItem) => {
  if (quote.status !== QuoteStatus.Approved && quote.expirationDate && isBefore(new Date(quote.expirationDate), startOfTomorrow())) {
    return QuoteStatus.Expired;
  }
  return quote.status;
};

export const getQuoteExpiration = (row: QuoteListItem) => {
  return new Date(row.expirationDate).getFullYear() >= 9999 ? '' : formatDate(row.expirationDate);
};
